import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';

import React from 'react';
import styles from './styles.module.less';

export const ArrowIcon = () => {
  return (
    <div className={styles['arrow-icon-container']}>
      <FontAwesomeIcon className={styles['arrow-icon']} icon={faArrowRight} />
    </div>
  );
};
